import { render, staticRenderFns } from "./VirtualLog.vue?vue&type=template&id=0a5f264c&scoped=true&"
import script from "./VirtualLog.vue?vue&type=script&lang=js&"
export * from "./VirtualLog.vue?vue&type=script&lang=js&"
import style0 from "./VirtualLog.vue?vue&type=style&index=0&id=0a5f264c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5f264c",
  null
  
)

export default component.exports